import { render } from "./homePage4.vue?vue&type=template&id=46a0ec14&scoped=true"
import script from "./homePage4.vue?vue&type=script&lang=js"
export * from "./homePage4.vue?vue&type=script&lang=js"

import "./homePage4.vue?vue&type=style&index=0&id=46a0ec14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a0ec14"]])

export default __exports__